var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"fieldContextMenu",staticClass:"absolute",attrs:{"data-test":"field-context-menu"}},[_c('ContextMenu',{attrs:{"buttons":_vm.buttons},on:{"cut":_vm.cutField,"copy":_vm.copyField,"paste":_vm.pasteField,"delete":_vm.deleteField,"closeContextMenu":_vm.closeContextMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }